<div class="main-wrapper">
   <div class="banner">
      <div class="logo"></div>
      <div class="banner-name">Online Payments</div>
   </div>

   <div class="main">
      <router-outlet></router-outlet>
   </div>

   <footer>
      <a href="http://{{theme.currentTheme.contactus}}" target="_blank"><mat-icon>help_outline</mat-icon></a>
      <span>
         Questions? Call us toll free at 1-800-843-4784<br/>
         Or contact one of our experienced customer support professionals <a href="http://{{theme.currentTheme.contactus}}" target="_blank">here</a><br/>
         Build {{e.version}}
      </span>
   </footer>
</div>
